import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import { DESKTOP_MAX_WIDTH } from './variables'

export const Container = styled.section`
  margin: 0 30px 30px;
`

export const Title = styled.h1`
  margin: 30px 0 30px;
  text-align: center;

  ${breakpoint('tablet')`
    font-size: 64px;
    text-align: center;
  `};
`
